import { useState, useEffect } from "react";
import { G, D2, BR, T2, TX } from "../theme";
import Avatar from "./Avatar";

export default function Sidebar(props) {
  var [aberto, setAberto] = useState(false);
  var [mobile, setMobile] = useState(window.innerWidth < 768);

  useEffect(function() {
    function onResize() {
      var isMobile = window.innerWidth < 768;
      setMobile(isMobile);
      if (!isMobile) setAberto(false);
    }
    window.addEventListener("resize", onResize);
    return function() { window.removeEventListener("resize", onResize); };
  }, []);

  var items = [
    {id:"painel",  icon:"🏠", label:"Visão Geral"},
    {id:"alunos",  icon:"👥", label:"Alunos"},
    {id:"links",   icon:"🔗", label:"Diagnósticos"},
    {id:"config",  icon:"⚙️", label:"Configurações"},
  ];

  function navegar(id) {
    props.onNav(id);
    setAberto(false);
  }

  var sidebarContent = (
    <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
      <div style={{padding:"1.5rem 1.25rem",borderBottom:"1px solid "+BR,display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
        <div>
          <div style={{fontSize:11,color:G,letterSpacing:3,fontWeight:600,marginBottom:2}}>RMS</div>
          <div style={{fontSize:20,fontWeight:700,color:"#fff"}}>2.0</div>
          <div style={{fontSize:10,color:T2,marginTop:2,letterSpacing:1}}>REPROGRAMAÇÃO METABÓLICA</div>
        </div>
        {mobile && (
          <button onClick={function(){ setAberto(false); }}
            style={{background:"none",border:"none",color:T2,fontSize:22,cursor:"pointer",padding:"4px",lineHeight:1}}>
            ✕
          </button>
        )}
      </div>
      <nav style={{flex:1,padding:"1rem 0.75rem"}}>
        {items.map(function(it) {
          return (
            <button key={it.id} onClick={function(){ navegar(it.id); }}
              style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"12px 12px",borderRadius:9,border:"none",
                background:props.active===it.id?G+"22":"none",color:props.active===it.id?G:T2,
                fontSize:14,fontWeight:props.active===it.id?600:400,cursor:"pointer",marginBottom:4,textAlign:"left"}}>
              <span style={{fontSize:18}}>{it.icon}</span>{it.label}
            </button>
          );
        })}
      </nav>
      <div style={{padding:"1rem",borderTop:"1px solid "+BR}}>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
          <Avatar s={props.user && props.user.avatar} src={props.user && props.user.foto_url} size={36}/>
          <div>
            <div style={{fontSize:12,fontWeight:500,color:TX}}>{props.user && props.user.nome && props.user.nome.split(" ").slice(0,2).join(" ")}</div>
            <div style={{fontSize:10,color:T2}}>{(props.user && props.user.especialidade) || "Profissional"}</div>
          </div>
        </div>
        <button onClick={props.onLogout} style={{width:"100%",padding:"8px 0",background:"none",border:"1px solid "+BR,borderRadius:7,color:T2,fontSize:12,cursor:"pointer"}}>Sair</button>
      </div>
    </div>
  );

  if (mobile) {
    return (
      <>
        <div style={{position:"fixed",top:0,left:0,right:0,zIndex:100,background:D2,borderBottom:"1px solid "+BR,
          display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0.75rem 1rem",height:56}}>
          <button onClick={function(){ setAberto(true); }}
            style={{background:"none",border:"none",cursor:"pointer",display:"flex",flexDirection:"column",gap:5,padding:4}}>
            <div style={{width:22,height:2,background:G,borderRadius:2}}/>
            <div style={{width:22,height:2,background:G,borderRadius:2}}/>
            <div style={{width:22,height:2,background:G,borderRadius:2}}/>
          </button>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div style={{fontSize:11,color:G,letterSpacing:2,fontWeight:600}}>RMS</div>
            <div style={{fontSize:16,fontWeight:700,color:"#fff"}}>2.0</div>
          </div>
          <Avatar s={props.user && props.user.avatar} src={props.user && props.user.foto_url} size={32}/>
        </div>

        {aberto && (
          <div onClick={function(){ setAberto(false); }}
            style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.6)"}}/>
        )}

        <div style={{
          position:"fixed",top:0,left:0,bottom:0,zIndex:201,width:260,
          background:D2,borderRight:"1px solid "+BR,
          transform:aberto?"translateX(0)":"translateX(-100%)",
          transition:"transform 0.25s ease",
        }}>
          {sidebarContent}
        </div>

        <div style={{height:56,flexShrink:0}}/>
      </>
    );
  }

  return (
    <div style={{width:220,minHeight:"100vh",background:D2,borderRight:"1px solid "+BR,display:"flex",flexDirection:"column",flexShrink:0}}>
      {sidebarContent}
    </div>
  );
}
